module.exports = __webpack_public_path__ + "static/media/FooterLogo-Atom@2x.1befd2c9.png";